<div class="col-md-6 col-sm-12" style="text-align: center">
  <img width="100px" src="./assets/images/loading.gif" alt="Loading..." />
</div>
